import { uniq, filter, get } from 'lodash';
import { MessageFromBE } from './types';
import getLastRetriedMessagesObject from './getLastRetriedMessagesObject';

interface IMessage extends Pick<MessageFromBE, 'retry' | 'channel' | 'externalStatus' | '_id'> {}

function getFilteredMessages<T extends IMessage[]>(messages: T) {
  const allMessages = [...messages];

  const onlyRetriedMessages = allMessages.filter((item) => !!item.retry?.originalMessage);
  const hasSomeRetriedMessage = onlyRetriedMessages.length > 0;

  if (!hasSomeRetriedMessage) {
    return allMessages.map((item) => ({ ...item, retriedChannels: [] }));
  }

  const allRetriedOriginalMessagesIds = onlyRetriedMessages.map((item) => item.retry?.originalMessage);
  const uniqRetriedOriginalMessagesIds = uniq(allRetriedOriginalMessagesIds);

  // remove the original message that was retried;
  const filteredMessagesByRetry = filter(allMessages, (item) => !uniqRetriedOriginalMessagesIds.includes(item?._id));
  const originalMessages = filter(allMessages, (item) => uniqRetriedOriginalMessagesIds.includes(item?._id));

  const lastRetriedMessagesObject = getLastRetriedMessagesObject(filteredMessagesByRetry, originalMessages);

  const filteredMessagesByCount = filteredMessagesByRetry.filter((item) => {
    if (!item.retry?.originalMessage) {
      return true;
    }
    const itemKey = item.retry.originalMessage ?? 'none';
    const lastRetriedMessagesObjectItem = get(lastRetriedMessagesObject, itemKey);
    return item._id === get(lastRetriedMessagesObjectItem, 'id');
  });

  const normalizedFilteredMessages = filteredMessagesByCount.map((item) => {
    if (!item.retry?.originalMessage) {
      return { ...item, retriedChannels: [] };
    }
    const itemKey = item.retry.originalMessage ?? 'none';
    const lastRetriedMessagesObjectItem = get(lastRetriedMessagesObject, itemKey);
    const lastRetriedMessagesObjectItemChannels = get(lastRetriedMessagesObjectItem, 'channels');
    return { ...item, retriedChannels: lastRetriedMessagesObjectItemChannels };
  });

  return normalizedFilteredMessages;
}

export default getFilteredMessages;
